import { render, staticRenderFns } from "./InputV2.vue?vue&type=template&id=4df1ec9d&scoped=true&"
import script from "./InputV2.vue?vue&type=script&lang=js&"
export * from "./InputV2.vue?vue&type=script&lang=js&"
import style0 from "./InputV2.vue?vue&type=style&index=0&id=4df1ec9d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df1ec9d",
  null
  
)

export default component.exports